import styled from "styled-components";

import { WellDetailCardData } from "api/data";

import { PanelField } from "../PanelField";
import { SPACING_METRIC_COLUMNS, SPACING_METRIC_FIELDS } from "../constants";
import { SectionLabel, StatGrid } from "../styles";

/**
 * Pinned under both gunbarrel views. Spacing is unaffected by a missing
 * survey, so it renders under an empty section as well.
 */
export function SpacingMetricsRow({
  wellData
}: {
  wellData: Maybe<WellDetailCardData>;
}): JSX.Element {
  return (
    <Wrapper>
      <SectionLabel>Spacing Metrics</SectionLabel>
      <StatGrid $columns={SPACING_METRIC_COLUMNS}>
        {SPACING_METRIC_FIELDS.map((field) => (
          <PanelField
            key={field.property}
            propertyName={field.property}
            fallbackLabel={field.fallbackLabel}
            isBoolean={field.boolean}
            isInteger={field.integer}
            label={field.label}
            booleanText={field.booleanText}
            wellData={wellData}
          />
        ))}
      </StatGrid>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex: none;
  border-top: 1px solid #e3e6e8;
  background: #f9fafc;
  padding: 10px 14px 14px;
`;
